import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ToastService {
  constructor(private toastr: ToastrService) {}

  show(message: string, action: string): void {
    this.toastr.success(message, action);
  }

  error(message: string, action: string): void {
    this.toastr.error(message, action);
  }

}
